const wrapFontName = (str = '') => str.trim()
  .replaceAll('\'', '')
  .replaceAll('\"', '')
  .split(', ')
  .map((family) => (family.search(/[\d\s]/g) === -1 ? family : `'${family}'`))
  .join(', ');

export default wrapFontName;
